export default __webpack_public_path__ + "static/pexels-andrea-piacquadio-3771087_-1defbbc763c1065fab8e51f65edc386b.jpg";